import tw from 'twin.macro'

const Link = tw.a`text-blue-800 dark:text-blue-400 hover:underline`

export default Link
